module.exports = __webpack_public_path__ + "img/custom-present-empty-model.38c1b8e5.png";